import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useMutation } from '@lumahealthhq/ui-model';
import { EModel } from '@lumahealthhq/ui-model-types';
import { getModelBasePath } from '@lumahealthhq/ui-utils';
var basePath = getModelBasePath(EModel.FollowupWorkflowGallery);
var crud = createCrud(basePath);

/* Default queries */
export var useFollowupWorkflowGalleryCount = crud.makeCount();
export var useFollowupWorkflowGalleryById = crud.makeFindById();
export var useFollowupWorkflowGalleryByIds = crud.makeFindByIds();
export var useFollowupWorkflowGalleryMany = crud.makeFindMany();
export var useFollowupWorkflowGalleryOne = crud.makeFindOne();
export var useFollowupWorkflowGalleryPagination = crud.makePagination();

/* Default mutations */
export var useFollowupWorkflowGalleryCreateOne = crud.makeCreateOne();
export var useFollowupWorkflowGalleryUpdateOne = crud.makeUpdateOne();
export var useFollowupWorkflowGalleryRemoveById = crud.makeRemoveById();

// Published use a different base path
var crudPublished = createCrud("".concat(basePath, "/published"));

/* Default queries */
export var useFollowupWorkflowGalleryPublishedCount = crudPublished.makeCount();
export var useFollowupWorkflowGalleryPublishedById = crudPublished.makeFindById();
export var useFollowupWorkflowGalleryPublishedByIds = crudPublished.makeFindByIds();
export var useFollowupWorkflowGalleryPublishedMany = crudPublished.makeFindMany();
export var useFollowupWorkflowGalleryPublishedOne = crudPublished.makeFindOne();
export var useFollowupWorkflowGalleryPublishedPagination = crudPublished.makePagination();

/* Default mutations */
export var useFollowupWorkflowGalleryPublishedCreateOne = crudPublished.makeCreateOne();
export var useFollowupWorkflowGalleryPublishedUpdateOne = crudPublished.makeUpdateOne();
export var useFollowupWorkflowGalleryPublishedRemoveById = crudPublished.makeRemoveById();

/* Custom mutations */
export function useFollowupWorkflowGalleryFork() {
  var axiosClient = useAxiosClient();
  function mutationFn(_x) {
    return _mutationFn.apply(this, arguments);
  }
  function _mutationFn() {
    _mutationFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      var _yield$axiosClient$pu, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.put("v2/".concat(basePath, "/").concat(id, "/fork"));
          case 2:
            _yield$axiosClient$pu = _context.sent;
            data = _yield$axiosClient$pu.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _mutationFn.apply(this, arguments);
  }
  return useMutation([basePath, getModelBasePath(EModel.FollowupWorkflow)], mutationFn);
}